module.exports = __webpack_public_path__ + "img/face5.f5adb415.png";